import banksList from "../../node_modules/bancos-brasileiros/bancos.json";

let Banks = banksList.map((bank) => ({
  value: bank.Code,
  label: `${bank.Code} - ${bank.Name}`,
}));

export default Banks;
